var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 331.6 98.6",
    viewBox: "0 0 331.6 98.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 51.3h44.2v10.2h-44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 34.3h44.2v10.2h-44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 17.3h44.2v10.2h-44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9.3-10.2 10.2h45.3v45.2l10.1-10.2v-45.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m292.3 25c-3.2-2.3-7-3.5-10.9-3.6-10.6 0-16.3 10.9-16.3 21.3 0 5.5 1.2 14.4 10.3 14.4 1.2 0 2.4-.1 3.6-.5l2.1-14.7h11.5l-2.3 17.1c-5 2.1-10.4 3.2-15.9 3.1-13 0-20.9-6.6-20.9-19.2 0-13.3 9.2-26.2 27.4-26.2 4.5 0 8.9 1 13 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m131.6 61.5 6.3-44.2h-11.6l-6.2 44.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m115.5 22.1.7-4.8h-25.7l-6.3 44.2h25.7l.7-4.7h-14.2l2.3-16.1h13.2l.6-4.2h-13.2l2-14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m329.9 22.1.7-4.8h-25.7l-6.2 44.2h25.7l.7-4.7h-14.2l2.2-16.1h13.2l.6-4.2h-13.2l2.1-14.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m174.9 22.1.7-4.8h-25.7l-6.3 44.2h11.5l3-20.8h13.1l.6-4.2h-13.1l2-14.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m210 22.1.7-4.8h-25.7l-6.3 44.2h11.6l2.9-20.8h13.2l.6-4.2h-13.2l2-14.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m236.6 61.5h10.9l-9.2-44.2h-8l-25 44.2h6.3l8-14.1h14zm-14.6-18.4 7.8-13.8 2.9 13.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m-33-23.5h397.7v154.7h-397.7z",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m85.9 82.3h2.6v14.9h-2.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m93.1 82.3h4l4 10.4 4-10.4h4v14.9h-2.5v-12.3l-4.6 12.3h-1.9l-4.5-12.3v12.3h-2.6v-14.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m113.8 82.3h4l4 10.4 4-10.4h4v14.9h-2.5v-12.3l-4.5 12.3h-1.8l-4.5-12.3v12.3h-2.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m141.4 82c4.1-.3 7.6 2.7 7.9 6.8v1c0 4.6-3.3 7.7-7.9 7.8-4.3.2-8-3.1-8.2-7.4s3.1-8 7.4-8.2zm0 13.2c3.1 0 5.1-2.4 5.1-5.5.1-2.8-2-5.2-4.9-5.4-2.8-.1-5.2 2-5.4 4.9v.5c.2 3.1 2.2 5.5 5.2 5.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m153.1 82.3h5.8c2.2 0 4.5 1 4.5 3.7 0 1.6-1.1 2.9-2.6 3.2 1.9.2 3.3 1.7 3.2 3.6 0 3.2-2.8 4.2-5.6 4.2h-5.3zm2.7 6h2.4c1.8 0 2.7-.8 2.7-1.9s-.9-1.9-2.9-1.9h-2.2zm0 6.6h2.4c1.4 0 3.2-.2 3.2-2.2 0-1.6-1-2.1-3.1-2.1h-2.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m167.9 82.3h2.7v14.9h-2.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m175.1 82.3h2.6v12.5h6.3v2.4h-9v-14.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m187.2 82.3h2.6v14.9h-2.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m194.3 82.3h9.8v2.4h-7.1v3.6h6.8v2.4h-6.8v4h7.6v2.4h-10.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m208.4 82.3h5.2c2.9 0 5.5.9 5.5 4.3.1 2.1-1.4 3.8-3.4 4l3.9 6.6h-3.2l-3.4-6.3h-1.9v6.3h-2.7zm4.7 6.3c1.5 0 3.2-.1 3.2-2.1 0-1.9-1.6-2-3-2h-2.3v4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe26869563e1b905aa85d167c31eac09.svg";
export { ForwardRef as ReactComponent };